import React, { useRef, useId, useEffect } from 'react';
import { X } from 'lucide-react';
export default function Modal({
  title,
  children,
  onClose,
  closeDisabled = false,
  wide = false,
  className = ''
}) {
  const ref = useRef(),
    opener = useRef(),
    restoreFrame = useRef(),
    titleId = useId();
  useEffect(() => {
    const dialog = ref.current,
      doc = dialog.ownerDocument,
      view = doc.defaultView,
      openedAt = view.location.href;
    if (restoreFrame.current) view.cancelAnimationFrame(restoreFrame.current);
    if (!dialog.contains(doc.activeElement)) opener.current = doc.activeElement;
    dialog.showModal();
    return () => {
      const trigger = opener.current;
      // Wait for removal and any replacement dialog or navigation to set focus.
      restoreFrame.current = view.requestAnimationFrame(() => {
        restoreFrame.current = null;
        if (dialog.isConnected && dialog.open) return;
        if (!trigger?.isConnected || trigger === doc.body || trigger === doc.documentElement) return;
        if (view.location.href !== openedAt || trigger.matches(':disabled') || trigger.closest('[inert]') || !trigger.getClientRects().length) return;
        const active = doc.activeElement;
        if (active !== doc.body && active !== doc.documentElement && !dialog.contains(active)) return;
        if ([...doc.querySelectorAll('dialog[open]')].some(openDialog => !openDialog.contains(trigger))) return;
        trigger.focus({preventScroll: true});
      });
    };
  }, []);
  return <dialog ref={ref} aria-labelledby={titleId} className={(wide ? 'modal wide' : 'modal') + ' ' + className} onCancel={e => {
    if (e.target !== ref.current) return;
    e.preventDefault();
    if (!closeDisabled) onClose();
  }} onClick={e => {
    if (e.target === ref.current && !closeDisabled) onClose();
  }}><header><h2 id={titleId}>{title}</h2><button className="icon-button" disabled={closeDisabled} onClick={onClose} aria-label="關閉"><X size={19} /></button></header>{children}</dialog>;
}
